// ui/Button — THE button (Design Standard v1). Four roles: primary (the one accent
// fill per screen), secondary, ghost, danger. Styles live in ds.css; no Tailwind
// colour classes, no gradient, no shadow. `outline` / `subtle` are accepted for the
// callers that predate the standard and render as secondary.
import React from 'react';
import clsx from 'clsx';
import './ds.css';

const VARIANT = { primary: 'primary', secondary: 'secondary', ghost: 'ghost', danger: 'danger', outline: 'secondary', subtle: 'secondary' };

export const Button = React.forwardRef(function Button(
  { children, variant = 'secondary', size = 'md', className = '', loading = false, icon = null, iconOnly = false, type = 'button', disabled, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={clsx('ds-btn', `ds-btn--${VARIANT[variant] || 'secondary'}`, size === 'sm' && 'ds-btn--sm', iconOnly && 'ds-btn--icon', className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <span className="ds-btn__spinner" aria-hidden="true" /> : icon}
      {children}
    </button>
  );
});

export default Button;
